export default {
  getList: (specifiedKey) => ['app-package-list-' + specifiedKey],
  getDetail: (specifiedKey) => ['app-package-detail-' + specifiedKey],
};
